import { useCallback, useState } from "react";

export function useHistory<T>(initialValue: T) {
  const [value, setValue] = useState<[T | undefined, T]>([
    undefined,
    initialValue,
  ]);

  const set = useCallback(
    (next: T) => setValue(([_, prev]) => [prev, next]),
    [],
  );
  const reset = useCallback(() => setValue([undefined, initialValue]), [initialValue]);

  return {
    set,
    reset,
    prev: value[0],
    next: value[1],
  };
}
